import { useMemo } from "react";
import { BuildingDao } from "./BuildingDao";

export const useBuildingDao = (): BuildingDao => {

  return useMemo(() => {
    return new BuildingDao();
  }, []);
};
